import { Stack } from "@altimateai/lego";
import { MyUsageTrendsResponse, OrgUsageTrendsResponse } from "@/pages/credits/types";
import { formatNumber } from "@/uiCore/components/formatters/format";

interface TopAITeammatesCardProps {
  teammates:
    | MyUsageTrendsResponse["top_ai_teammates"]["teammates"]
    | OrgUsageTrendsResponse["top_ai_teammates"]["teammates"];
  totalCredits: number;
}

export const TopAITeammatesCard = ({ teammates, totalCredits }: TopAITeammatesCardProps) => {
  if (teammates.length === 0) {
    return (
      <Stack justify="center" align="center" className="al-h-32 al-text-gray-500">
        No AI teammates data available
      </Stack>
    );
  }

  return (
    <div className="al-space-y-5 overflow-auto">
      {teammates.map((t, index) => {
        const percentage = totalCredits > 0 ? (t.credits_consumed / totalCredits) * 100 : 0;
        return (
          <Stack gap={"none"} direction={"column"} key={index} className="al-space-y-1">
            <span className="al-font-medium al-text-gray-900 al-truncate">{t.teammate}</span>
            <div className="al-w-full al-bg-gray-200 al-rounded-full al-h-2">
              <div
                className="al-bg-purple-400 al-h-2 al-rounded-full al-transition-all"
                style={{ width: `${Math.min(percentage, 100)}%` }}
              />
            </div>
            <span className="al-text-gray-600 al-font-normal">
              {formatNumber(t.credits_consumed)} credits ({percentage.toFixed(1)}%)
            </span>
          </Stack>
        );
      })}
    </div>
  );
};
